import { render } from "./CloudtecGym.vue?vue&type=template&id=fae8459a&scoped=true"
import script from "./CloudtecGym.vue?vue&type=script&lang=js"
export * from "./CloudtecGym.vue?vue&type=script&lang=js"

import "./CloudtecGym.vue?vue&type=style&index=0&id=fae8459a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae8459a"]])

export default __exports__